import __request__ from "routing/request";
export function fields(limit, requestOptions) {
  return __request__("GET", "/system/fields", null, { "limit": limit }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
